<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-header">{{ data.memberName }} — Connections</h2>

  <div mat-dialog-content>
    <ngx-spinner></ngx-spinner>

    <!-- Existing Connections Table -->
    <div class="section-label">Connected Companies</div>
    <div class="table-container">
      <table mat-table [dataSource]="connectionsDataSource" class="mat-elevation-z0"
             [hidden]="connectionsDataSource.data.length === 0">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">
            <span class="name-cell">
              <a [href]="getCompanyUrl(row)" target="_blank" class="company-link-btn" title="Open {{ row.type === 'opb' ? 'OPB company' : 'company board' }}">
                <mat-icon>open_in_new</mat-icon>
              </a>
              {{ row.name }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row">
            <span class="type-badge" [ngClass]="row.type === 'opb' ? Helpers.getEntityTypeBadgeClass('OPB Company') : 'type-other'">
              {{ row.type === 'opb' ? 'OPB Company' : row.membershipLabel }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            @if (row.type === 'opb') {
              <button mat-icon-button color="warn" (click)="onDeleteOpbConnection(row)" class="action-btn">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="connectionsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: connectionsColumns;"></tr>
      </table>

      @if (connectionsDataSource.data.length === 0) {
        <div class="empty-state">No connections found.</div>
      }
    </div>

    <!-- Search OPB Companies Section -->
    <div class="section-label search-section-label">Add OPB Company Connection</div>
    <div class="search-form">
      <form (ngSubmit)="onSearch()" class="search-inline">
        <mat-form-field appearance="fill">
          <mat-label>OPB Company Name</mat-label>
          <input matInput [(ngModel)]="searchName" name="searchName" placeholder="Search by name">
        </mat-form-field>
        <button mat-flat-button color="primary" type="submit" [disabled]="!searchName.trim()">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </form>
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="searchDataSource" matSort #searchSort="matSort" class="mat-elevation-z0"
             [hidden]="searchDataSource.data.length === 0">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let item">{{ item.name }}</td>
        </ng-container>

        <ng-container matColumnDef="countryName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
          <td mat-cell *matCellDef="let item">{{ item.countryName }}</td>
        </ng-container>

        <ng-container matColumnDef="sectorName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sector</th>
          <td mat-cell *matCellDef="let item">{{ item.sectorName }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <button mat-icon-button (click)="onAddOpbConnection(item)"
                    [matTooltip]="isAlreadyConnected(item.id) ? 'Already connected' : 'Add connection'"
                    [disabled]="isAlreadyConnected(item.id)" class="add-btn">
              <mat-icon>{{ isAlreadyConnected(item.id) ? 'check_circle' : 'add_circle' }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="searchColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: searchColumns;"></tr>
      </table>

      @if (searchDataSource.data.length === 0) {
        <div class="empty-state">No OPB companies found. Please search to see results.</div>
      }

      <mat-paginator #searchPaginator
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        [hidden]="searchDataSource.data.length === 0"
        aria-label="Select page">
      </mat-paginator>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onClose()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
  </div>
</div>
